
<template>
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">
    <!-- FLORES DECORATIVAS PRINCIPALES -->
    <img src="@/assets/elemento2.png" class="flor flor-1" alt="" />
    <img src="@/assets/elemento2.png" class="flor flor-2" alt="" />
    <img src="@/assets/elemento2.png" class="flor flor-3" alt="" />
    <img src="@/assets/elemento2.png" class="flor flor-4" alt="" />

    <!-- NUEVAS FLORES LATERALES (FLORNUEVA.PNG) -->
    <img src="@/assets/flornueva.avif" class="flor flor-lateral-izq" alt="" />
    <img src="@/assets/flornueva.avif" class="flor flor-lateral-der" alt="" />

    <!-- BOLA DISCO -->
    <img src="@/assets/disco.png" class="bola bola-izquierda" alt="" />

    <!-- IMAGEN CON RECasdasdasdsaasdaasdsddsORTE -->
    <div class="imagen-xv-wrapper">
      <img src="@/assets/A7402697_11zon.webp" class="imagen-xv" alt="Foto protagonista" />
    </div>

    <!-- TEXTO PRINCIPAL -->
    <section class="texto-xv">
      <p class="frase-bendicion">
        Con la bendición de Dios <br />
        y de mis padres
      </p>

      <h1 class="nombre-protagonista">Eynar Esmael Espinoza &nbsp;</h1>

      <div class="ampersand-padres">&</div>

      <h1 class="nombre-protagonista"> Ana Esmael Carcache&nbsp; </h1>
      
      <div class="separador-elegante" aria-hidden="true"></div>

    

      <p class="parrafo-presentacion">
      <br>   Dios te instruirá y te guiará por el mejor camino en tu vida.
      </p>
      <p class="salmo-ref">Salmo 32:8</p>
    </section>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      const foto = $('.imagen-xv-wrapper')

      const flores = [
        '.flor-1',
        '.flor-2',
        '.flor-3',
        '.flor-4',
        '.flor-5',
        '.flor-6',
        '.flor-lateral-izq',
        '.flor-lateral-der'
      ].flatMap($)

      const texto = [
        '.frase-bendicion',
        '.nombre-protagonista:not(.padrino-nombre)',
        '.ampersand-padres',
        '.separador-elegante',
        '.padrinos-label',
        '.padrino-nombre',
        '.parrafo-presentacion',
        '.salmo-ref'
      ].flatMap($)

      // Estado inicial invisible para prevenir FOUC
      gsap.set([...foto, ...flores, ...texto], { autoAlpha: 0, y: 30 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

          // 1. Entrada de la foto con zoom y desenfoque elegante
          tl.fromTo(
            foto,
            { scale: 0.92, y: 45, filter: 'blur(8px)' },
            { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 1.2 }
          )

          // 2. Aparición artística de las flores con opacidades y rotaciones variadas
          tl.to(
            flores,
            {
              autoAlpha: (i) => (i % 2 === 0 ? 0.9 : 0.65), // Opacidades sutiles distintas
              y: 0,
              rotate: () => gsap.utils.random(-10, 10),
              duration: 1,
              stagger: 0.08
            },
            '-=0.8'
          )

          // 3. Aparición fluida de los textos en cascada
          tl.to(
            texto,
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.85,
              stagger: 0.1
            },
            '-=0.5'
          )

          // 4. Respiración muy sutil y elegante de la foto (bucle infinito ligero)
          gsap.to(foto, {
            scale: 1.012,
            duration: 4,
            yoyo: true,
            repeat: -1,
            ease: 'sine.inOut'
          })

          io.disconnect()
        })
      }, { threshold: 0.3 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>

<style scoped>
.portada-xv {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #ebdce0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 48px 16px 56px;
}

/* Marco con recorte superior redondeado y optimización GPU */
.imagen-xv-wrapper {
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 6px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  padding: 6px;
  background-color: #ebdce0;
  will-change: transform, filter, opacity;
  transform: translateZ(0);
}

.imagen-xv-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 176px 176px 0 0;
  display: block;
}

.imagen-xv {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Texto */
.texto-xv {
  max-width: 620px;
  text-align: center;
  margin-top: 22px;
  padding: 0 8px;
  will-change: transform, opacity;
}

.frase-bendicion {
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color: #2f2e2e;
  line-height: 1.5;
  margin: 20px 0 10px;
}

.separador-elegante {
  width: 110px;
  height: 2px;
  margin: 12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}

.nombre-protagonista {
  font-family: "titulos", cursive;
  font-size: 49px;
  color: #c195a5;
  margin: 0 0 8px 0;
  line-height: 1.1;
}

.parrafo-presentacion {
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color: #2f2e2e;
  line-height: 1.5;
  line-height: 1.7;
  margin-top: 6px;
}

/* FLORES DECORATIVAS Y OPTIMIZACIÓN DE RENDIMIENTO */
.flor {
  position: absolute;
  width: min(44vw, 240px);
  z-index: 10;
  transform-origin: center;
  will-change: transform, opacity;
  pointer-events: none; /* Evita interrupciones de eventos del mouse innecesarias */
}

.flor-1 { top: -10px; left: -50px; z-index: 5; opacity: 0.4; }
.flor-2 { top: 60px; right: -80px; transform: rotate(-80deg); z-index: 1; width: min(40vw, 220px) !important; opacity: 0.6; }
.flor-3 { bottom: 10px; left: -90px; transform: rotate(-30deg); z-index: 9; opacity: 0.5; width: min(40vw, 180px) !important;  }
.flor-4 { top: 80px; left: 0px; transform: translateX(-50%) rotate(-12deg); width: min(40vw, 200px); z-index: 6; opacity: 0.5; }
.flor-5 { bottom: 40px; transform: translateX(-50%) rotate(-12deg); right: 0px; width: min(46vw, 240px); z-index: 8; opacity: 0.4; }
.flor-6 { top: 390px; transform: translateX(-50%) rotate(-12deg); right: -150px; width: min(34vw, 180px) !important; z-index: 99; opacity: 0.65; }

/* NUEVAS FLORES LATERALES (flornueva.png) */
.flor-lateral-izq {
  top: 45%;
  left: -120px;
  width: min(38vw, 150px);
  transform: rotate(45deg) !important;
  opacity: 0.55;
  z-index: 4;
}

.flor-lateral-der {
  top: 35%;
  right: -40px;
  width: min(28vw, 140px);
  transform: rotate(-35deg);
  opacity: 0.5;
  z-index: 4;
}

/* AMPERSAND PADRES */
.ampersand-padres {
  font-family: "Cormorant Garamond", serif;
  font-size: 46px;
  color: #d9b7c6;
  line-height: 1;
  margin: -4px 0 4px;
}

/* BOLA DISCO */
.bola {
  position: absolute;
  width: 120px;
  animation: girar 10s linear infinite;
  z-index: 1;
  opacity: 0 !important;
  will-change: transform;
}
.bola-izquierda { left: -20px; bottom: -50px; z-index: 9; }

@keyframes girar {
  from { transform: rotate(0); }
  to { transform: rotate(360deg); }
}

/* ESTILOS ESPECÍFICOS DE PADRINOS */
.padrinos-label {
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color: #2f2e2e;
  margin-top: 12px;
}

.padrino-nombre {
  font-family: "titulos", cursive;
  font-size: 52px !important;
  color: #e6b1c4;
  margin: 4px 0;
}

.salmo-ref {
  display: block;
  text-align: right;
  margin-top: 6px;
  font-size: 13px;
  color: #888;
  font-family: 'Montserrat', sans-serif;
  opacity: 0.8;
}

/* Responsive refinado */
@media (min-width: 992px) {
  .portada-xv { padding-top: 64px; }
  .imagen-xv-wrapper { margin-top: 0; }
  .flor-lateral-izq { left: 10px; }
  .flor-lateral-der { right: 10px; }
}
</style>

```